/* eslint-disable jsx-a11y/media-has-caption */
import VideocamIcon from '@material-ui/icons/Videocam';
import { QuotedMessage } from '@src/types';
import { useIntl } from 'react-intl';

type ChatMessageVideoQuotedProps = {
  title: React.ReactNode;
  message: QuotedMessage;
};

const ChatMessageVideoQuoted: React.FC<ChatMessageVideoQuotedProps> = ({
  title,
  message,
}) => {
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {title}
        <div className="ChatMessageContentQuoted">
          <VideocamIcon style={{ marginRight: 3 }} />
          {!message?.text?.length ? (
            intl.formatMessage({ id: 'AgentChatTimeline.video.text' })
          ) : (
            <p>{message.text}</p>
          )}
        </div>
      </div>
      <video src={message.mediaUrl} style={{ marginLeft: 10, height: 60 }} />
    </div>
  );
};

export default ChatMessageVideoQuoted;
